// External deps
import { useContext } from 'react';

// Internal deps
import WorkReportContext from '../context/WorkReportProvider';

export default function useCalendar() {
  return useContext(WorkReportContext);
}
